// แยกโค้ดพิมพ์รายงานสรุปจดหมายออกมาจาก ReportLetter.js
// หมายเหตุ: ข้อมูลที่แสดงบนหน้าจอกับที่พิมพ์ออกมาไม่เหมือนกัน จึงแยกไฟล์ไว้ต่างหาก
// ใช้ตารางต่อเนื่อง ให้เบราว์เซอร์แบ่งหน้าเอง (เต็มหน้า)
export function printReportLetter({
    displayData = [],
    dateLabel = '',
    filterType = 'ทั้งหมด',
}) {
    const rows = displayData.map((d, i) => `
        <tr>
            <td style="text-align:center">${i + 1}</td>
            <td style="text-align:center">${d.CONTNO || '-'}</td>
            <td>${d.customerFullName || '-'}</td>
            <td style="text-align:center">${d.parcelNo || '-'}</td>
            <td style="text-align:center">${d.parcelNoResponse || '-'}</td>
            <td style="text-align:center">${d.status1 || '-'}</td>
            <td style="text-align:center">${d.status3 || '-'}</td>
            <td style="text-align:center">${d.status4 || '-'}</td>
        </tr>
    `).join('')
    const win = window.open('', '_blank')
    win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"/><title>รายงานจดหมาย</title>
        <style>
            @page{size:A4 portrait;margin:12mm}
            html,body{width:186mm;max-width:186mm;overflow:hidden;-webkit-print-color-adjust:exact;print-color-adjust:exact}
            *{font-family:'Sarabun','TH Sarabun New',sans-serif;font-size:9pt;box-sizing:border-box;margin:0;padding:0}
            body{color:#000}
            h2{text-align:center;font-size:14pt;font-weight:bold;margin-bottom:3px}
            .sub{text-align:center;font-size:8pt;color:#555;margin-bottom:8px}
            hr{border:none;border-top:2px solid #f0f0f0;margin:6px 0}
            table{width:100%;border-collapse:collapse;table-layout:fixed}
            col.c1{width:5%}col.c2{width:12%}col.c3{width:21%}col.c4{width:13%}col.c5{width:13%}col.c6{width:12%}col.c7{width:12%}col.c8{width:12%}
            th{background:#fafafa;font-weight:bold;font-size:8pt;padding:4px 3px;border:1px solid #d9d9d9;text-align:center}
            td{border:1px solid #e8e8e8;padding:3px 4px;font-size:8pt;word-break:break-word;vertical-align:middle}
            tr:nth-child(even) td{background:#fafafa}
            thead{display:table-header-group}
            .footer{margin-top:8px;font-size:8pt;color:#888;text-align:right;border-top:1px solid #f0f0f0;padding-top:4px}
        </style></head><body>
        <h2>รายงานสรุปจดหมาย</h2>
        <div class="sub">ช่วงวันที่: ${dateLabel} | ประเภท: ${filterType}</div>
        <hr/>
        <table><colgroup><col class="c1"/><col class="c2"/><col class="c3"/><col class="c4"/><col class="c5"/><col class="c6"/><col class="c7"/><col class="c8"/></colgroup>
        <thead><tr><th>ลำดับ</th><th>เลขสัญญา</th><th>ชื่อลูกค้า</th><th>EMS ไป</th><th>EMS กลับ</th><th>ประเภท</th><th>คอนเฟิร์ม</th><th>ตอบกลับ</th></tr></thead>
        <tbody>${rows}</tbody></table>
        <div class="footer">จำนวนทั้งหมด ${displayData.length} รายการ</div>
        </body></html>`)
    win.document.close()
    setTimeout(() => { win.print(); win.close() }, 400)
}

export default printReportLetter
